import { httpRequest } from "../../utils/HttpRequest";
import { ItemDetailed, MaterialDetailed, IAppointmentField, IAppointmentSearch, IAppointmentList, IAppointmentDetail, IAppointmentRoSettleAndWhConfirm, IAppointmentStatistics } from "./appointmentType"

class AppointmentService {
    async page(searchVo: IAppointmentSearch) {
        const apiUrl = "/zzw-vrm/appointment/findPage";
        return await httpRequest.post<IAppointmentList>(apiUrl, searchVo);
    }
    async total(searchVo: IAppointmentSearch) {
        const apiUrl = "/zzw-vrm/appointment/total";
        return await httpRequest.post<IAppointmentStatistics>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/zzw-vrm/appointment/findById/${id}`;
        return await httpRequest.get<IAppointmentDetail>(apiUrl);
    }

    async insert(insertVo: IAppointmentField) {
        const apiUrl = "/zzw-vrm/appointment/insert";
        return await httpRequest.post<IAppointmentDetail>(apiUrl, insertVo);
    }
    async update(updateVo: IAppointmentField) {
        const apiUrl = "/zzw-vrm/appointment/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    async getChooseList(insertVo: IAppointmentField) {
        const apiUrl = "/zzw-vrm/repairTemplate/select/page";
        return await httpRequest.post<any>(apiUrl, insertVo);
    }
    async findVehicleDetial(insertVo: IAppointmentField) {
        const apiUrl = "/zzw-vrm/maintenance/getMsg";
        return await httpRequest.post<any>(apiUrl, insertVo);
    }
    // 库房确认
    async warehousing(params: IAppointmentRoSettleAndWhConfirm) {
        const apiUrl = "/zzw-vrm/appointment/warehousing";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //维修用料明细删除
    async materialDelete(params: MaterialDetailed) {
        const apiUrl = "/zzw-vrm/appointment/materialDelete";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //维修项目明细删除
    async itemDelete(params: ItemDetailed) {
        const apiUrl = "/zzw-vrm/appointment/itemDelete";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //结算
    async settl(params: IAppointmentRoSettleAndWhConfirm) {
        const apiUrl = "/zzw-vrm/appointment/settle";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //作废
    async invalidate(params: object) {
        const apiUrl = "/zzw-vrm/appointment/invalidate";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //重新加载维修项目得数据
    async projectQuery(params: string[]) {
        const apiUrl = "/zzw-vrm/base/item/projectQuery";
        return await httpRequest.post<ItemDetailed[]>(apiUrl, params);
    }
    //重新加载维修用料得数据
    async find(params: string[]) {
        const apiUrl = "/zzw-vrm/stock/find";
        return await httpRequest.post<MaterialDetailed[]>(apiUrl, params);
    }
    //预约转维修
    async transfer(params: IAppointmentField) {
        const apiUrl = "/zzw-vrm/appointment/transfer";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //导出
    async export(params: IAppointmentField) {
        const apiUrl = "/zzw-vrm/appointment/export";
        return await httpRequest.postFile(apiUrl, params);
    }
    //详情导出    
    async detailsExport(params: IAppointmentField) {
        const apiUrl = "/zzw-vrm/appointment/repairFormExport";
        // const apiUrl = "/zzw-vrm/appointment/detailsExport";
        return await httpRequest.postFile(apiUrl, params);
    }
    //明细导出(无单价)
    async detailsNoPriceExport(params: IAppointmentField) {
        const apiUrl = "/zzw-vrm/appointment/repairFormExportNoPrice";
        return await httpRequest.postFile(apiUrl, params);
    }
    //打印次数
    async printNum(id: string) {
        const apiUrl = `/zzw-vrm/appointment/print/${id}`;
        return await httpRequest.get(apiUrl);
    }
}
export const appointmentService = new AppointmentService();
